<template>
  <div>
    <v-select
      v-model="education_system_id"
      class="px-2"
      :items="educationSystems"
      item-text="name"
      item-value="id"
      label="Sistema de ensino"
    >
      <template
        v-if="education_system_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="education_system_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    educationSystemIdSelected: { type: Number, default: undefined }
  },
  data: () => ({
    educationSystems: [],
    education_system_id: null
  }),
  watch: {
    education_system_id () {
      this.setEducationSystem()
    },
    educationSystemIdSelected () {
      this.educationSystems.find(educationSystem => educationSystem.id === this.educationSystemIdSelected) && (this.education_system_id = this.educationSystemIdSelected)
    }
  },

  async created () {
    await this.listEducationSystems()
  },

  methods: {
    setEducationSystem () {
      this.$emit('setEducationSystem', this.education_system_id)
    },
    async listEducationSystems () {
      try {
        this.educationSystems = await this.$api.listEducationSystems()
        this.educationSystems.find(educationSystem => educationSystem.id === this.educationSystemIdSelected) && (this.education_system_id = this.educationSystemIdSelected)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os sistema de ensino, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
